import React from "react";
import "./styles.scss";

interface BannerInfoMessageProps extends React.PropsWithChildren {
  text?: string;
}

export const BannerInfoMessage = ({text, children}: BannerInfoMessageProps) => {
    return (
        <>
            <p className="banner-info-message">{text ? text : children}</p>
        </>
    )
}